import { AppBundle } from '@/utils/app-bundles';
import { RedirectRegexToTargetApp, oldParcelRegex } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function ParcelRedirectRoute() {
  return <RedirectRegexToTargetApp regex={oldParcelRegex} targetApp={AppBundle.DesignStudio} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/parcel/$')({
  component: ParcelRedirectRoute,
});
